/* unplugin-vue-components disabled */import script from "./UserInfoInputPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoInputPopup.vue?vue&type=script&setup=true&lang=js"

import "./UserInfoInputPopup.vue?vue&type=style&index=0&id=274c4efc&lang=scss"

const __exports__ = script;

export default __exports__